import React from 'react'
import { useSelector } from 'react-redux'
import {Outlet} from "react-router-dom"
import Sidebar from '../Components/core/Dashboard/Sidebar'

const Dashboard = () => {

    const {loading: authLoading} = useSelector( (state) => state.auth );
    const {loading: profileLoading} = useSelector( (state) => state.profile );



    if(profileLoading || authLoading) {
        return (
            <div className="flex min-h-[calc(100vh-3.5rem)] w-full items-center justify-center bg-richblack-900 font-inter text-richblack-200">
                Loading...
            </div>
        )
    }


  return (
    <div className="relative flex min-h-[calc(100vh-3.5rem)] w-full bg-richblack-900 font-inter">
        <Sidebar />
        <div className="min-h-0 min-w-0 flex-1 overflow-y-auto border-l border-richblack-700 bg-richblack-900 pb-24 lg:pb-10">
            <div className="py-10">
                <Outlet />
            </div>
        </div>
    </div>
  )
}

export default Dashboard
